import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";

export type CommonHeaderProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "handleShare" | "handleRefetchActivities"
>;

export const getCommonHeaderProps = ({
  activity,
  type,
  isFeed,
  handleShare,
  handleRefetchActivities
}: CommonHeaderProps) => ({
  activity,
  type,
  isFeed,
  onShare: handleShare,
  handleCloseActivitySuccess: handleRefetchActivities
});
